<template>
  <div class="ok md:p-8 p-3">
    <div class="w-full">
      <svg-icon
        :name="icon"
        class="md:h-12 h-5 cursor-pointer"
        original
      />
    </div>
    <div class="nom md:mt-20 md:pt-8 pt-3">
      {{ label }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
  .nom{
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
  }
  .ok{
    background: #FBFCFE;
    border: 2px solid $background-gray-dev;
    box-sizing: border-box;
  }
  @media screen and (max-width: 600px){
    .nom{
      font-size: 14px;
    }

  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .nom{
      font-size: 20px;
    }
  }
</style>
